'use strict';
'use es6';

/**
 * Diff arrays of primitive values (numbers, strings, booleans, undefined, null, and symbols)
 *
 * @param {Array} array Array to inspect
 * @param {Array} values Values to exclude
 * @returns {Array} Returns an array of filtered values
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
var diffPrimitives = exports.diffPrimitives = function diffPrimitives(a, b) {
  return a.filter(function (x) {
    return !b.includes(x);
  });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/utils/diffPrimitives.js
// module id = 798
// module chunks = 2 3